export default __webpack_public_path__ + "static/media/eye.6d684511.svg";